import React, { useState } from 'react'
import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react'
import { Images, Tag, Users, Star, Pencil, Link2, EllipsisVertical, Laugh, Trash, Minus, Maximize2, X } from 'lucide-react';
import { Checkbox } from '@chakra-ui/react'
import { Input } from '@chakra-ui/react';
// import './Email.css';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
} from '@chakra-ui/react'
export default function Email() {
    const [isOpen, setIsOpen] = useState(false);
    const openEmail = () => {
        setIsOpen(true)
    }
    const closeEmail = () => {
        setIsOpen(false)
    }
    return (
        <div>
            <Modal isOpen={isOpen} onClose={closeEmail}>
                <ModalOverlay />
                <ModalContent>
                    <div className='d-flex gap-2 position-absolute' style={{ bottom: 20, left: 15 }}>
                        <Link2 size="20" color='#ff176b' />
                        <Laugh size="20" color='#ff176b' />
                        <Trash size="20" color='#ff176b' />
                        <EllipsisVertical size="20" color='#ff176b' />
                    </div>
                    <ModalHeader style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#ff176b' }}>
                        <div>
                            New Message
                        </div>
                        <div className='d-flex'>
                            <Minus size="20" color='#ff176b' style={{ marginRight: '10px' }} />
                            <Maximize2 size="20" color='#ff176b' style={{ marginRight: '10px' }} />
                            <X onClick={closeEmail} size="20" color='#ff176b' style={{ marginRight: '10px' }} />
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        <Input placeholder='To' style={{ fontSize: '1rem' }} />
                        <Input placeholder='Subject' style={{ fontSize: '1rem', fontWeight: 'bold' }} className='mt-3' />
                        <textarea rows={5} className='form-control' style={{ marginTop: '10px', border: 'none', outline: 'none', resize: 'none' }} placeholder='Compose email'>
                        </textarea>
                    </ModalBody>
                    <ModalFooter>
                        <button className='create-button' style={{ backgroundColor: '#ff176b ' }}>Send</button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            <Tabs>
                {/* <TabList>
                    <div className='tab-item'>
                        <Images color='grey' size={20} />
                        <Tab>Primary</Tab>
                    </div>
                    <div className='tab-item'>
                        <Tag color='grey' size={20} />
                        <Tab>Promotions</Tab>
                        <p className='notification'>31 new</p>
                    </div>
                    <div className='tab-item'>
                        <Users color='grey' size={20} />
                        <Tab>Social</Tab>
                        <p className='social'>17 new</p>
                    </div>
                </TabList> */}

<div className="tab-scrollable-container" style={{ maxHeight: '200px', overflowY: 'auto' }}>
    <TabList>
        <div className='tab-item'>
            <Images color='grey' size={20} />
            <Tab>Primary</Tab>
        </div>
        <div className='tab-item'>
            <Tag color='grey' size={20} />
            <Tab>Promotions</Tab>
            <p className='notification'>31 new</p>
        </div>
        <div className='tab-item'>
            <Users color='grey' size={20} />
            <Tab>Social</Tab>
            <p className='social'>17 new</p>
        </div>
        {/* Add more tab items here to demonstrate scrolling */}
        
        {/* You can continue adding more items as needed */}
    </TabList>
</div>



                <TabPanels >
                    <TabPanel>
                        <div>
                            <div className='email-entry d-flex gap-3'>
                                <div><Checkbox></Checkbox></div>
                                <Star color='grey' size={20} />
                                <p style={{ fontWeight: "600" }}>noreply@unstop.news</p>
                                <p>INR 32 LPA & Stipend @ 1 lac/Month | 200+ Offers-GRID 6.0  APPLY NOW! - its time to showcase Intrest</p>
                                <p><b>23 JUL</b></p>
                            </div>
                            <div className='email-entry d-flex gap-3'>
                                <div><Checkbox></Checkbox></div>
                                <Star color='grey' size={20} />
                                <p style={{ fontWeight: "600" }}>noreply@unstop.news</p>
                                <p>INR 32 LPA & Stipend @ 1 lac/Month | 200+ Offers-GRID 6.0  APPLY NOW! - its time to showcase Intrest</p>
                                <p><b>23 JUL</b></p>
                            </div>
                            <div className='email-entry d-flex gap-3'>
                                <div><Checkbox></Checkbox></div>
                                <Star color='grey' size={20} />
                                <p style={{ fontWeight: "600" }}>noreply@unstop.news</p>
                                <p>INR 32 LPA & Stipend @ 1 lac/Month | 200+ Offers-GRID 6.0  APPLY NOW! - its time to showcase Intrest</p>
                                <p><b>23 JUL</b></p>
                            </div>
                            <div className='email-entry d-flex gap-3'>
                                <div><Checkbox></Checkbox></div>
                                <Star color='grey' size={20} />
                                <p style={{ fontWeight: "600" }}>noreply@unstop.news</p>
                                <p>INR 32 LPA & Stipend @ 1 lac/Month | 200+ Offers-GRID 6.0  APPLY NOW! - its time to showcase Intrest</p>
                                <p><b>23 JUL</b></p>
                            </div>
                            <div className='email-entry d-flex gap-3'>
                                <div><Checkbox></Checkbox></div>
                                <Star color='grey' size={20} />
                                <p style={{ fontWeight: "600" }}>noreply@unstop.news</p>
                                <p>INR 32 LPA & Stipend @ 1 lac/Month | 200+ Offers-GRID 6.0  APPLY NOW! - its time to showcase Intrest</p>
                                <p><b>23 JUL</b></p>
                            </div>
                            <div className='email-entry d-flex gap-3'>
                                <div><Checkbox></Checkbox></div>
                                <Star color='grey' size={20} />
                                <p style={{ fontWeight: "600" }}>noreply@unstop.news</p>
                                <p>INR 32 LPA & Stipend @ 1 lac/Month | 200+ Offers-GRID 6.0  APPLY NOW! - its time to showcase Intrest</p>
                                <p><b>23 JUL</b></p>
                            </div>
                            <div className='email-entry d-flex gap-3'>
                                <div><Checkbox></Checkbox></div>
                                <Star color='grey' size={20} />
                                <p style={{ fontWeight: "600" }}>noreply@unstop.news</p>
                                <p>INR 32 LPA & Stipend @ 1 lac/Month | 200+ Offers-GRID 6.0  APPLY NOW! - its time to showcase Intrest</p>
                                <p><b>23 JUL</b></p>
                            </div>
                            <div className='email-entry d-flex gap-3'>
                                <div><Checkbox></Checkbox></div>
                                <Star color='grey' size={20} />
                                <p style={{ fontWeight: "600" }}>noreply@unstop.news</p>
                                <p>INR 32 LPA & Stipend @ 1 lac/Month | 200+ Offers-GRID 6.0  APPLY NOW! - its time to showcase Intrest</p>
                                <p><b>23 JUL</b></p>
                            </div>
                            <div className='email-entry d-flex gap-3'>
                                <div><Checkbox></Checkbox></div>
                                <Star color='grey' size={20} />
                                <p style={{ fontWeight: "600" }}>noreply@unstop.news</p>
                                <p>INR 32 LPA & Stipend @ 1 lac/Month | 200+ Offers-GRID 6.0  APPLY NOW! - its time to showcase Intrest</p>
                                <p><b>23 JUL</b></p>
                            </div>
                        </div>

                        {/* button for desktop view start here  */}
                        <div className=' position-fixed d-none d-sm-block' style={{ bottom: '2rem', left: '85%' }}>
                            <button className="new-button mx-2" onClick={openEmail}><Pencil size="18px" /><span className='ms-1'>Compose</span></button>
                        </div>
                        {/* button for desktop view ends here  */}

                        {/* button for mobile view start here  */}
                        <div className="position-fixed d-flex justify-content-end d-lg-none" style={{ bottom: '2rem', left: '0', right: '0' }}>
                            <button className="new-button mx-2 btn btn-primary" onClick={openEmail}>
                                <Pencil size="18px" />
                                <span className='ms-1'>Compose</span>
                            </button>
                        </div>
                        {/* button for mobile view ends here  */}



                    </TabPanel>
                    <TabPanel>
                        <div>
                            <div className='email-entry d-flex gap-3'>
                                <div><Checkbox></Checkbox></div>
                                <Star color='grey' size={20} />
                                <p style={{ fontWeight: "600" }}>Zuno by foundit</p>
                                <p>Hiring Challenge Inside - Your path to polo Alto Network Starts from here! Are you ready for the first step</p>
                                <p><b>25 JUL</b></p>
                            </div>
                            <div className='email-entry d-flex gap-3'>
                                <div><Checkbox></Checkbox></div>
                                <Star color='grey' size={20} />
                                <p style={{ fontWeight: "600" }}>Zuno by foundit</p>
                                <p>Hiring Challenge Inside - Your path to polo Alto Network Starts from here! Are you ready for the first step</p>
                                <p><b>25 JUL</b></p>
                            </div>
                            <div className='email-entry d-flex gap-3'>
                                <div><Checkbox></Checkbox></div>
                                <Star color='grey' size={20} />
                                <p style={{ fontWeight: "600" }}>Zuno by foundit</p>
                                <p>Hiring Challenge Inside - Your path to polo Alto Network Starts from here! Are you ready for the first step</p>
                                <p><b>25 JUL</b></p>
                            </div>
                            <div className='email-entry d-flex gap-3'>
                                <div><Checkbox></Checkbox></div>
                                <Star color='grey' size={20} />
                                <p style={{ fontWeight: "600" }}>Zuno by foundit</p>
                                <p>Hiring Challenge Inside - Your path to polo Alto Network Starts from here!Are you ready for the first step</p>
                                <p><b>25 JUL</b></p>
                            </div>
                        </div>
                        {/* button for desktop view start here  */}
                        <div className='position-fixed d-none d-sm-block' style={{ bottom: '2rem', left: '85%' }}>
                            <button className="new-button mx-2" onClick={openEmail}><Pencil size="18px" /><span className='ms-1'>Compose</span></button>
                        </div>
                        {/* button for desktop view ends here  */}

                        {/* button for mobile view start here  */}
                        <div className="position-fixed d-flex justify-content-end d-lg-none" style={{ bottom: '2rem', left: '0', right: '0' }}>
                            <button className="new-button mx-2 btn btn-primary" onClick={openEmail}>
                                <Pencil size="18px" />
                                <span className='ms-1'>Compose</span>
                            </button>
                        </div>
                        {/* button for mobile view ends here  */}

                    </TabPanel>
                    <TabPanel>
                        <div>
                            <div className='email-entry d-flex gap-3'>
                                <div><Checkbox></Checkbox></div>
                                <Star color='grey' size={20} />
                                <p style={{ fontWeight: "600" }}>Skillyst by Foundit</p>
                                <p>Your Free personlized fridge-magnet and photobook😍Tap here to Apply !</p>
                                <p><b>23 JUL</b></p>
                            </div>
                            <div className='email-entry d-flex gap-3'>
                                <div><Checkbox></Checkbox></div>
                                <Star color='grey' size={20} />
                                <p style={{ fontWeight: "600" }}>Skillyst by Foundit</p>
                                <p>Your Free personlized fridge-magnet and photobook 😍 Tap here to Apply !</p>
                                <p><b>23 JUL</b></p>
                            </div>
                            <div className='email-entry d-flex gap-3'>
                                <div><Checkbox></Checkbox></div>
                                <Star color='grey' size={20} />
                                <p style={{ fontWeight: "600" }}>Skillyst by Foundit</p>
                                <p>Your Free personlized fridge-magnet and photobook 😍 Tap here to Apply !</p>
                                <p><b>23 JUL</b></p>
                            </div>
                            <div className='email-entry d-flex gap-3'>
                                <div><Checkbox></Checkbox></div>
                                <Star color='grey' size={20} />
                                <p style={{ fontWeight: "600" }}>Skillyst by Foundit</p>
                                <p>Your Free personlized fridge-magnet and photobook 😍 Tap here to Apply !</p>
                                <p><b>23 JUL</b></p>
                            </div>
                        </div>
                        {/* button for Desktop view start here  */}
                        <div className='position-fixed d-none d-sm-block' style={{ bottom: '2rem', left: '85%' }}>
                            <button className="new-button mx-2" onClick={openEmail}><Pencil size="18px" /><span className='ms-1'>Compose</span></button>
                        </div>
                        {/* button for Desktop view ends here  */}


                        {/* button for mobile view start here  */}
                        <div className="position-fixed d-flex justify-content-end d-lg-none" style={{ bottom: '2rem', left: '0', right: '0' }}>
                            <button className="new-button mx-2 btn btn-primary" onClick={openEmail}>
                                <Pencil size="18px" />
                                <span className='ms-1'>Compose</span>
                            </button>
                        </div>
                        {/* button for mobile view ends here  */}

                    </TabPanel>
                </TabPanels>
            </Tabs>

        </div>
    )
}
